import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { HelpersService } from "src/app/core/services/helpers.service";
import { ModalNotifyService } from "src/app/core/services/modal-notify.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { PropertiesSettings, PropertiesSettings as ps } from "../../../core/configuration/properties-settings";
import {
  PetitumRevisioneAdapter
} from "../../components/fascicolo/sezione-economica-valore-add-revisione/petitum-revisione-adapter";
import { FascicoloFull } from "../../models/fascicolo/fascicolo-full";
import { PetitumRevisione } from "../../models/petitum-revisione";
import { SezioneEconomica } from "../../models/sezioni/sezione-economica";
import { TipoPetitum } from "../../models/tipologiche/tipo-petitum";
import { UtilityCommon } from "../../utils/utility-common";
import { BaseForm } from "../base-Form";

export abstract class ValoreEconomicoRevisioneFormComponent extends BaseForm {
  idPetitumDefault = ps.ID_TIPO_PETITUM_NON_PRESENTE;
  request: PetitumRevisione;
  originalRequest: PetitumRevisione;
  minDataRevisione: number;
  petitumSubscription: Subscription;
  petitumRevisioneForm: FormGroup;
  idTipoRevisionePetitum = ps.ID_TIPO_REVISIONE_PETITUM;
  tipiPetitumOptions: TipoPetitum[] = [];
  idPetitumQuantificabile = ps.ID_TIPO_PETITUM_QUANTIFICABILE;
  idTipoRevisioneWizard = ps.ID_TIPO_REVISIONE_WIZARD;
  recuperoCrediti: boolean;
  abstract getEdit(): boolean;
  abstract getPetitumRevisione(): PetitumRevisione;
  abstract getRequest(request: PetitumRevisione);
  abstract getSezione() : SezioneEconomica;
  abstract getFascicolo(): FascicoloFull;

  constructor(
    protected operationService: OperationsService,
    protected campiForm: FormBuilder,
    protected helpers: HelpersService,
    protected modalNotifyService: ModalNotifyService
  ) {
    super();
  }

  initRequest() {
    // debugger;
   this.originalRequest = new PetitumRevisioneAdapter(this.getPetitumRevisione()).petitumRevisione
   this.request = new PetitumRevisioneAdapter( this.getPetitumRevisione()).petitumRevisione;
     /*if (!this.request.tipoPetitum) {
      this.request.tipoPetitum = new TipoPetitum();
    }*/
    if (this.tipiPetitumOptions && this.tipiPetitumOptions.length > 0) {
      if (this.recuperoCrediti) {
        this.request.tipoPetitum = this.tipiPetitumOptions.find(
          (el) => el.id == this.idPetitumQuantificabile
        );
      } /*else {
       this.request.tipoPetitum = null;
     }*/
    }
  }

  createForm() {
    // debugger;
    this.initRequest();
    /*if(!this.getEdit()) {
        this.request.dataRevisioneDa = new Date().getTime();
      }*/
    this.petitumRevisioneForm = this.campiForm.group({
      tipoPetitum: [this.request.tipoPetitum, Validators.required],
      dataRevisioneDa: [this.request.dataRevisioneDa, Validators.required],
      importoPetitum: [this.request.importoPetitum, Validators.max(PropertiesSettings.MAX_VALUE_DECIMAL)],
      compensi: [this.request.compensi],
      maggiorDanno: [this.request.maggiorDanno],
      rivalutazione: [this.request.rivalutazione],
      interessiSpeseLegali: [this.request.interessiSpeseLegali],
      spese: [this.request.spese],
      altro: [this.request.altro],
      motivoRevisione: [this.request.motivoRevisione],
    });
  }

  populateSelect() {
    if (this.tipiPetitumOptions.length === 0) {
      this.helpers.getTipiPetitum().subscribe((response) => {
        this.tipiPetitumOptions = response;
        // this.tipiPetitumOptions = this.tipiPetitumOptions.filter(
        //   (el) => el.id !== this.idPetitumDefault
        // );
        if (this.recuperoCrediti) {
          this.request.tipoPetitum = this.tipiPetitumOptions.find(
            (el) => el.id == this.idPetitumQuantificabile
          );
        } /*else {
          this.request.tipoPetitum = null;
        }*/
      });
    }
  }

  save() {
    let requestCopy: PetitumRevisione = new PetitumRevisioneAdapter(
      this.request
    ).petitumRevisione;
    console.log(requestCopy);
    requestCopy.ripartizioneEqua = false;
    if (requestCopy.importoPetitum) {
      requestCopy.importoPetitum = requestCopy.importoPetitum
        .toString()
        .replace(",", ".");
    }

    if (requestCopy.compensi) {
      requestCopy.compensi = requestCopy.compensi.toString().replace(",", ".");
    }

    if (requestCopy.spese) {
      requestCopy.spese = requestCopy.spese.toString().replace(",", ".");
    }

    if (requestCopy.altro) {
      requestCopy.altro = requestCopy.altro.toString().replace(",", ".");
    }

    if (requestCopy.percentualeSoccombenza) {
      requestCopy.percentualeSoccombenza = requestCopy.percentualeSoccombenza
        .toString()
        .replace(",", ".");
    }
    if(!!this.checkContributoUnificato()){
      this.petitumSubscription = this.modalNotifyService.notifyConfirmObservable.subscribe(result =>{
        if(!!result){
          this.getRequest(requestCopy);
        } else{
          this.petitumSubscription.unsubscribe();
        }
      });
      this.modalNotifyService.notifyCustom('Confermando il cambio di tipo petitum, verrà annullato il valore inserito nel contributo unificato. Continuare?');
    } else{
      this.getRequest(requestCopy);
    }
  }

  checkContributoUnificato():boolean {
    // in inserimento check sull'ultima revisione inserita
    if(!!this.inserimento){
      let revisioniPetitum: PetitumRevisione[] = this.getSezione() ? this.getSezione().petitum.petitumRevisioni.filter((p: PetitumRevisione) =>
      p.tipoRevisione.id === this.idTipoRevisionePetitum || p.tipoRevisione.id === this.idTipoRevisioneWizard) : [];
      if (revisioniPetitum.length > 0) {
        let lastRevisione = UtilityCommon.orderBy(revisioniPetitum, 'dataRevisioneDa:DESC')[0];
        return ((this.request.tipoPetitum.id!==lastRevisione.tipoPetitum.id) && !!(this.getSezione().contributoUnificato));
      } else {
        return false;
      }
    }
    // in modifica check sulla revisione corrente
    else {
      return ((this.request.tipoPetitum.id!==this.originalRequest.tipoPetitum.id) && !!(this.getSezione().contributoUnificato));
    }
  }

  getUrlDataMinRevisione():string {
    return "/rs/ops/gp/" + this.getFascicolo().praticaBase.tipoPratica.endpoint + '/fasc/' + this.getFascicolo().tipoFascicolo.endpoint + '/' + this.getFascicolo().id + '/sez/economici/' + this.getSezione().id + '/petitum/revisione/data';
  }

}
